import React, { useState, useRef, useEffect } from 'react';
import ReactTooltip from '@huner2/react-tooltip';
import { useSelector, useDispatch } from 'react-redux';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
// import Checkbox from "../../../features/customize-button/components/form/Checkbox";
import SwitchBig from '../../../components/SwitchBig';
// import Button from '../../../components/Button';
import {
  selectSecondaryFilter,
  updateSecondaryFilter,
} from '../secondaryFilterSlice';
import translate from '../../../utilities/translator';
import { scrollToResults } from '../../../utilities/helpers';
import { pushEvent } from '../../../utilities/analytics';
import {
  REFUNDABILITY_FILTER_UPDATE_EVENT,
  SEC_FILTER_OPEN,
} from '../../../constants/analyticEvents';
import { clearSelectedHotel } from '../../search/searchSlice';
import { filterClearClick, filterSaveClick, setLastChangedFilter } from '../../../appSlice';
import { clearPrefetchDeals } from '../../dealsList/prefetchDealsSlice';

export default function Refundability({ isOpen, setIsOpen, side }) {
  const { data } = useSelector(selectSecondaryFilter);
  const { flex } = data;
  const name = translate('holidayFinder.secondaryFilter.refundability');

  const ref = useRef();
  const dispatch = useDispatch();
  // const [cancellation, setCancellation] = useState(freeCancellation);
  const [localFlexState, setLocalFlexState] = useState(flex);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  useOnClickOutside(ref, () => isOpen && setIsOpen(false));

  useEffect(() => {
    if (localFlexState.active !== flex.active) {
      setLocalFlexState(flex);
    }
  }, [flex.active]);

  /* const onSaveClick = (event) => {
    setIsOpen(false);
    dispatch(filterSaveClick());
    dispatch(clearPrefetchDeals());
    dispatch(
      updateSecondaryFilter({
        updatedValue: localFlexState,
        filter: 'flex'
      })
    );
    event.stopPropagation();
    dispatch(clearSelectedHotel());
    pushEvent(REFUNDABILITY_FILTER_UPDATE_EVENT, { flex: localFlexState, type: 'save' });
    scrollToResults();
  }; */

  const onClearClick = (event) => {
    setIsOpen(false);
    dispatch(filterClearClick());
    setLocalFlexState({
      ...localFlexState,
      active: false
    });
    // setCancellation(false);
    dispatch(
      updateSecondaryFilter({
        updatedValue: {
          ...localFlexState,
          active: false
        },
        filter: 'flex'
      })
    );
    /* dispatch(updateSecondaryFilter({
      updatedValue: false, filter: "freeCancellation"
    })); */
    event.stopPropagation();
    scrollToResults();
    pushEvent(REFUNDABILITY_FILTER_UPDATE_EVENT, { flex: localFlexState, type: 'clear' });
  };

  const openFilter = (st) => {
    if (!isOpen) {
      pushEvent(SEC_FILTER_OPEN, { filterName: 'refundability' });
    }
    setIsOpen(st);
  };

  const changeFlex = () => {
    const newFlexState = {
      ...localFlexState,
      active: !localFlexState.active
    };
    setLocalFlexState(newFlexState);
    dispatch(filterSaveClick());
    dispatch(clearPrefetchDeals());
    dispatch(
      updateSecondaryFilter({
        updatedValue: newFlexState,
        filter: 'flex'
      })
    );
    dispatch(setLastChangedFilter('secondaryFilter'));
    dispatch(clearSelectedHotel());
    setTimeout(() => setIsOpen(false), 500);
    pushEvent(REFUNDABILITY_FILTER_UPDATE_EVENT, { flex: newFlexState, type: 'save' });
  };

  const isActiveFilter = flex.active;

  let activeName = '';
  if (isActiveFilter) {
    activeName = `
      ${flex.active ? translate('holidayFinder.secondaryFilter.refundableWithFlex') : ''}
    `;
  }

  return (
    <div className="filter-item filter-item-v2" ref={ref}>
      <p
        className={`filter-item__name ${
          isOpen ? 'filter-item__name-open' : ''
        } ${isActiveFilter ? 'filter-item__name-active' : ''}`}
        onClick={() => openFilter(!isOpen)}
        role="menuitem"
        ref={ref}
        tabIndex="0"
      >
        <span>{isActiveFilter ? activeName : name}</span>
        {isActiveFilter ? (
          <i onClick={onClearClick} className="ri-close-line close" />
        ) : (
          <i className="ri-arrow-down-s-line chevron" />
        )}
      </p>
      {isOpen && (
        <div className={`filter-body filter-body-v2 ${side}`} style={{ minWidth: '360px' }}>
          <div className="flex flex-col gap-3">
            {/* <Checkbox
              onChange={() => changeFlex()}
              label={
                <span className="flex-filter-label">
                  <span>
                    <b>{translate('holidayFinder.secondaryFilter.refundableWithFlex')}</b>
                    <span>{translate('holidayFinder.secondaryFilter.cancelUntil24hbeforeDeparture')}</span>
                  </span>
                  <i className="ri-information-line" data-tip={'Some TEXT!'} />
                  <ReactTooltip effect="solid" className="tooltip-container" />
                </span>
              }
              checked={localFlexState.active}
            /> */}
            <SwitchBig
              className="label-medium move-switch flex justify-between"
              value={localFlexState.active}
              label={
                <span className="flex-filter-label">
                  <span>
                    <b>{translate('holidayFinder.secondaryFilter.refundableWithFlex')}</b>
                    <span>{translate('holidayFinder.secondaryFilter.cancelUntil24hbeforeDeparture')}</span>
                  </span>
                  <span className="ri-information-line" data-tip={translate('holidayFinder.secondaryFilter.flexTooltip')} />
                  <ReactTooltip effect="solid" className="tooltip-container" />
                </span>
              }
              onChange={() => changeFlex()}
            />
            {/* <Checkbox
              onChange={() => setCancellation(!cancellation)}
              label={translate('holidayFinder.secondaryFilter.cancellationFlexibility.checkbox')}
              checked={cancellation}
            /> */}
          </div>
          {/* <div className="filter-footer-v2 flex gap-3">
            <button className="panel-button panel-button__clear py-4 px-6 rounded-full" onClick={onClearClick}>
              {translate('holidayFinder.buttons.Clear')}
            </button>
            <button className="panel-button panel-button__save py-4 px-6 rounded-full" onClick={onSaveClick}>
              {translate('holidayFinder.buttons.Save')}
            </button>
          </div> */}
        </div>
      )}
    </div>
  );
}
